import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.1 13.85c.69 0 1.25.56 1.25 1.25v2.2c0 .69-.56 1.25-1.25 1.25H8.8c-.69 0-1.25-.56-1.25-1.25v-2.2c0-.69.56-1.25 1.25-1.25zm-9.05 3.2h8.8v-1.7h-8.8z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.125 13.975c.316 0 .601.13.806.34a1.123 1.123 0 0 1-.68 1.915l-.114.006h-.012A1.125 1.125 0 0 1 4 15.111V15.1c0-.622.504-1.125 1.125-1.125M12.54 6.686c1.519 0 2.826.906 3.41 2.206l.106.265a.675.675 0 0 1-1.27.456 2.39 2.39 0 0 0-2.246-1.578.675.675 0 0 1 0-1.35"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4.325a7.423 7.423 0 0 1 7.398 6.825H20.7c.966 0 1.75.784 1.75 1.75v6.6a1.75 1.75 0 0 1-1.75 1.75H3.3a1.75 1.75 0 0 1-1.75-1.75v-6.6c0-.966.783-1.75 1.75-1.75h1.302A7.423 7.423 0 0 1 12 4.325M3.3 12.65a.25.25 0 0 0-.25.25v6.6c0 .138.112.25.25.25h17.4a.25.25 0 0 0 .25-.25v-6.6a.25.25 0 0 0-.25-.25zM12 5.675a6.076 6.076 0 0 0-6.046 5.475h4.031a2.025 2.025 0 0 1 4.03 0h4.03A6.076 6.076 0 0 0 12 5.675m0 5c-.303 0-.556.2-.642.475h1.284a.67.67 0 0 0-.642-.475",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgComponent);
export const DvdPlayerIcon = ForwardRef;